import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from 'lodash';

import {
    Typography,
    FormControl,
    Pagination,
    IconButton,
    Tooltip,
    Modal,
    Box,
    Button,
    Card,
    Alert,
    CardContent,
    CardHeader,
    Divider,
    TextField,
    MenuItem,
    InputLabel,
    Select,
    FormHelperText
} from "@mui/material";
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import ClearIcon from "@mui/icons-material/Clear";
import Snackbar from "@mui/material/Snackbar";
import LinearProgress from "@mui/material/LinearProgress";
import Notification from "../../pages/General/Notification";
import { fetchBoxData } from '../../pages/Settings/Box/boxSlice';
import { fetchProfile } from '../Settings/Profile/profileSlice';
import {
  fetchPickOrderDetail,
  fetchPickOrderDetailitems,
  putOrderItemsDetails,
  resetOrderPickNotification
} from "../../pages/OrderPicklist/orderpicklistSlice";
import {
    resetOrderNotifications,
    updateBulkDimension
} from '../../pages/Orders/ordersSlice';
//Custom Components Import Ends

const DimUpdatePage = () => {
    const dispatch = useDispatch();
    const profile = useSelector(state => state.profile.profile);
    const box = useSelector(state => state.box)
    const orders = useSelector(state => state.orders);
    const orderpicklistitems = useSelector((state) => state.orderpicklist);
    const [boxData, setBoxData] = useState([])
    const [meta, setMeta] = useState(orders.ordersData.meta);
    const [alert, setAlert] = useState(false);
    const [open, setOpen] = useState(false);
    const [orderId, setOrderId] = useState("");
    const [orderSubmit, setorderSubmit] = useState(false);
    const [boxNameScan, setBoxNameScan] = useState("");
    const [boxNameFocus, setBoxNameFocus] = useState(false);
    const initialBoxValues = {
        "_id":0,
        "box_name": 'custom',
        "box_length": "",
        "box_width": "",
        "box_height": "",
        "box_dimension_unit": "",
        "box_actual_weight": "",
        "box_weight_unit": "",
    }
    const [dimensionValue, setDimensionValue] = useState(initialBoxValues);
    const [dimensionsErrors, setDimensionsErrors] = useState({});
    const filterOptions = createFilterOptions({
        matchFrom: 'start',
        stringify: (option) => option.box_name,
        });

    const getChooseMeasurement = (currentvalue) => {
    let filteredCurrentValue = {};
    let tempValue = "";
    boxData &&
    boxData.map((key) => {
        if (key._id == currentvalue && tempValue == "") {
            filteredCurrentValue = key;
            tempValue = "success";
        }
        });
    return filteredCurrentValue;
    };

    const onBoxDimensionChange=(event)=>{
        let packageFieldData = {...dimensionValue};
        if(event.target.name==='choosenmeasurement'){
            if (event.target.value != 0) {
                box && box.data && box.data.map((boxData) => {
                    if (boxData._id === event.target.value) {
                        setDimensionValue({
                            ...dimensionValue,
                            "_id": event.target.value,
                            "box_name": boxData.box_name,
                            "box_length": parseFloat(boxData.box_length).toFixed(2),
                            "box_width": parseFloat(boxData.box_width).toFixed(2),
                            "box_height": parseFloat(boxData.box_height).toFixed(2),
                            "box_dimension_unit": boxData.box_length_unit,
                            "box_actual_weight": parseFloat(boxData.box_weight).toFixed(2),
                            "box_weight_unit": boxData.box_weight_unit
                        });
                        setDimensionsErrors({})
                    }
                })
            }else{
                setDimensionValue({
                    ...dimensionValue,
                    "_id":0,
                    "box_name": 'custom',
                    "box_length": "",
                    "box_width": "",
                    "box_height": "",
                    "box_dimension_unit": "",
                    "box_actual_weight": "",
                    "box_weight_unit": ""
                });
                setDimensionsErrors({})
            }
        }else{
            packageFieldData[event.target.name] = event.target.value;
            setDimensionValue(packageFieldData);
            validator({ [event.target.name]: event.target.value })
        }
    }
    const validator = (fieldValues) => {
        let temp = { ...dimensionsErrors }
        // if ('box_name' in fieldValues)
        //     temp.box_name = fieldValues.box_name ? "" : "This field is required."
        // if (fieldValues && fieldValues.box_name && fieldValues.box_name.length < 3)
        //     temp.box_name = "Box Name required minimum 3 characters"
        if ('box_length' in fieldValues)
            temp.box_length = fieldValues.box_length ? "" : "This field is required."
        if (fieldValues && fieldValues.box_length && fieldValues.box_length <= 0)
            temp.box_length = "Length is not a negative number or 0"
        if ('box_dimension_unit' in fieldValues)
            temp.box_dimension_unit = fieldValues.box_dimension_unit ? "" : "This field is required."
        if ('box_width' in fieldValues)
            temp.box_width = fieldValues.box_width ? "" : "This field is required."
        if (fieldValues && fieldValues.box_width && fieldValues.box_width <= 0)
            temp.box_width = "Width is not a negative number  or 0"
        if ('box_height' in fieldValues)
            temp.box_height = fieldValues.box_height ? "" : "This field is required."
        if (fieldValues && fieldValues.box_height && fieldValues.box_height <= 0)
            temp.box_height = "Height is not a negative number  or 0"
        if(typeof (profile && profile.use_auto_weight)==='undefined'){
            if ('box_actual_weight' in fieldValues)
                temp.box_actual_weight = fieldValues.box_actual_weight ? "" : "This field is required."
            if (fieldValues && fieldValues.box_actual_weight && fieldValues.box_actual_weight <= 0)
                temp.box_actual_weight = "Weight is not a negative number  or 0"
            if ('box_weight_unit' in fieldValues)
                temp.box_weight_unit = fieldValues.box_weight_unit ? "" : "This field is required."
        }
        setDimensionsErrors({
            ...temp
        })

        if (fieldValues === dimensionValue)
            return Object.values(temp).every(x => x == "")
    }

    const onInputClear = () => {
        setOrderId("");
        setorderSubmit(false)
        setDimensionValue(initialBoxValues)
        setBoxNameScan("")
        setDimensionsErrors({})
    };

    const onBoxNameScanClear =() =>{
        setBoxNameScan("")
        setDimensionsErrors({})
        setDimensionValue(initialBoxValues)
    }
    const handleSubmit = () => {
        setorderSubmit(true)
        dispatch(fetchPickOrderDetail(orderId));
    };

    const handleSnackClose = () => {
        setOpen(false);
        dispatch(resetOrderPickNotification())
      };

    const handleBoxScanSearch = () => {
        const value = boxNameScan;
        // Find box with matching box_name
        const foundBox = boxData.find((box) => box.box_name.toLowerCase() === value.toLowerCase());
        if(typeof foundBox!=='undefined'){
            setDimensionValue({
                ...dimensionValue,
                "_id":foundBox._id,
            })
            let event = {
                "target": {
                    "name": "choosenmeasurement",
                    "value":foundBox._id
                }
            }
            onBoxDimensionChange(event);
        }else{
            setDimensionValue(initialBoxValues)
        }
        setorderSubmit(true)
      };

    const addBulkDimensionsForm =()=>{
        const isValid = validator(dimensionValue)
        if (isValid) {
            let docIdArray=[]
            docIdArray.push(orderpicklistitems && orderpicklistitems.orderpickdetail &&
                orderpicklistitems.orderpickdetail.data &&
                orderpicklistitems.orderpickdetail.data._id)
            let docid={'docids':docIdArray}
            Object.assign(dimensionValue, docid);
            setDimensionsErrors({})
            console.log(dimensionValue)
            if(orderId!==""){
                dispatch(updateBulkDimension(profile && profile.id,dimensionValue,meta))
            }
        }
    }

     useEffect(() => {
            if (orderpicklistitems && orderpicklistitems.orderpickdetail &&
                orderpicklistitems.orderpickdetail.data && orderpicklistitems.orderpickdetail.data.length!==0 && orderpicklistitems.orderpickdetail.data.product_info && orderId!=='') {
                const dimensionsArray = [orderpicklistitems.orderpickdetail.data.product_info];
                dimensionsArray.map((item) => {
                    setDimensionValue({
                        ...dimensionValue,
                        "_id": 0,
                        "box_name": "",
                        "box_length": item && item.dimensions && item.dimensions.length && item.dimensions.length >0 ? parseFloat(item.dimensions.length).toFixed(2) : 0,
                        "box_width": item &&  item.dimensions.width && item.dimensions.width>0 ? parseFloat(item.dimensions.width).toFixed(2) : 0,
                        "box_height": item && item.dimensions && item.dimensions.height && item.dimensions.height >0 ? parseFloat(item.dimensions.height).toFixed(2) : 0,
                        "box_dimension_unit": item && item.dimensions && item.dimensions.height_unit!=='' ? item.dimensions.height_unit :"",
                        "box_actual_weight": item && item.actual_weight >0 ?parseFloat(item.actual_weight).toFixed(2) : 0,
                        "box_weight_unit": item && item.weight_unit!=='' ? item.weight_unit :"",
                    });
                })
            }
    }, [orderpicklistitems])

    useEffect(() => {
            dispatch(fetchBoxData(false));
            dispatch(fetchProfile())
        }, [dispatch]);

    useEffect(() => {
        if(dimensionValue && dimensionValue.length!=='' && orderId!=='' && boxNameScan!==''){
            addBulkDimensionsForm()
            setDimensionsErrors({})
        }
    }, [dimensionValue]);

     useEffect(() => {
            let tempBoxData=[]
            let customValue={"_id":0,"box_name":"custom"}
            tempBoxData.push(customValue)
            let boxOriginalData = box && box.data.filter(function( obj ) {
                return  obj.hide !== true;
                });
            if (boxOriginalData.length !== 0) {
                boxOriginalData.map((item) => {
                    tempBoxData.push(item)
                })
                setBoxData(tempBoxData)
            }else{
                setBoxData(tempBoxData)
            }
        }, [box && box.data]);

    useEffect(() => {
        if(orderpicklistitems && orderpicklistitems.orderpickdetail && orderpicklistitems.orderpickdetail.notification && orderpicklistitems.orderpickdetail.notification.messageType=='error'){
            setAlert(true)
            setOpen(true)
        }else{
          setAlert(false)
          setOpen(false)
        }
    
      },[orderpicklistitems.orderpickdetail])

      useEffect(() => {
        if(orders && orders.addBulkDimension.notification && orders.addBulkDimension.notification.messageContent  && orders.addBulkDimension.notification.messageContent[0]  && orders.addBulkDimension.notification.messageContent[0]==='dimensions updated successfully'){
            setOrderId("")
            setorderSubmit(false)
            setDimensionValue(initialBoxValues)
            setBoxNameScan("")
        }
      },[orders && orders.addBulkDimension])
    return (
        <>
        {alert && (
                <Snackbar
                  open={open}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  autoHideDuration={6000}
                  onClose={handleSnackClose}
                >
                  <Alert
                    severity={"error"}
                    style={{ justifyContent: "center", margin: "10px 0" }}
                  >
                    <span> {orderpicklistitems.orderpickdetail.notification.messageContent.message}</span>
                  </Alert>
                </Snackbar>
              )}
        {(orders && orders.addBulkDimension.notification && orders.addBulkDimension.notification.show) &&
                        <Notification
                            is_open={orders.addBulkDimension.notification.show}
                            messageType={orders.addBulkDimension.notification.messageType}
                            messages={orders.addBulkDimension.notification.messageContent}
                            handleClose={() => dispatch(resetOrderNotifications())}
        />}
            <div>
                <div className="sccardhead">
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="h5" gutterBottom component="div">
                            Dim Update
                        </Typography>
                    </div>
                </div>
            </div>
            <div className="scmaincard">
                <Card style={{ padding: "40px 0" }}>
                    <div className="sc--form--center">
                        <TextField
                            value={orderId}
                            name={"orderid"}
                            label="Order Id*"
                            size={"small"}
                            onInput={(e) => {
                                setOrderId(e.target.value)
                                setorderSubmit(false)
                                setBoxNameFocus(true)
                            }
                            }
                            variant="standard"
                            InputProps={{
                                endAdornment: orderId ? (
                                    <IconButton size="small" onClick={() => onInputClear()}>
                                        <ClearIcon />
                                    </IconButton>
                                ) : undefined,
                            }}
                            onKeyUp={(event) => {
                                if (event.key == "Enter") handleSubmit();
                            }}
                            inputRef={(orderinput) => {
                                if (orderId == '' && orderSubmit == false)
                                    orderinput && orderinput.focus()
                            }
                            }
                            style={{ width: "200px" }}
                        />
                        <Button
                            variant="contained"
                        onClick={handleSubmit}
                        style={{
                            color: orderId == "" ? "rgba(0, 0, 0, 0.26)" : "#fff",
                            backgroundColor:
                                orderId == "" ? "rgba(0, 0, 0, 0.12)" : "#1976d2",
                            cursor: orderId == "" ? "not-allowed" : "pointer",
                            pointerEvents: orderId == "" ? "none" : "auto",
                            marginLeft: "20px",
                        }}
                        >
                            Search
                        </Button>
                    </div>
                    {orderSubmit && orderId!=='' && orderpicklistitems && orderpicklistitems.orderpickdetail &&
                orderpicklistitems.orderpickdetail.data && orderpicklistitems.orderpickdetail.data.length!==0 && orderpicklistitems.orderpickdetail.data.order && orderpicklistitems.orderpickdetail.data.order.id && orderId===orderpicklistitems.orderpickdetail.data.order.id &&
                    <div className="sc--form--center" style={{marginTop:20}}>
                        <div>
                            <p style={{marginTop:5,marginBottom:'unset'}}> OrderId - <b>{orderpicklistitems && orderpicklistitems.orderpickdetail &&
                                orderpicklistitems.orderpickdetail.data &&
                                orderpicklistitems.orderpickdetail.data.order && orderpicklistitems.orderpickdetail.data.order.id}</b></p>
                                            <p style={{marginTop:5,marginBottom:'unset'}}>Order Status - <b>{orderpicklistitems && orderpicklistitems.orderpickdetail &&
                                orderpicklistitems.orderpickdetail.data &&
                                orderpicklistitems.orderpickdetail.data.order && orderpicklistitems.orderpickdetail.data.order.status}</b></p>
                        </div>
                    </div>
                    }
                </Card>

                <Divider />

                {orderpicklistitems &&
                          orderpicklistitems.orderpickdetail &&
                          orderpicklistitems.orderpickdetail.loading && <LinearProgress />}

                <Card
                    sx={{ marginTop: "20px" }}
                    className="sc--cardhead--details"
                >
                    <div style={{ width: "100%", background: "#fff" }}>
                        <CardHeader
                            title="Dim Details"
                        />
                        {orders && orders.addBulkDimension && orders.addBulkDimension.loading &&
                            <LinearProgress />
                        }
                        <Divider />

                        <CardContent style={{width:'50%',margin:'auto'}}>
                            {orderId !=='' &&  Object.keys(orderpicklistitems && orderpicklistitems.orderpickdetail &&
                orderpicklistitems.orderpickdetail.data).length!==0 &&
                                <div className="sc--form--center" style={{ margin: '10px 0' }}>
                                    <TextField id="insurance-amount-id"
                                        label="Box Name Scan"
                                        variant="standard"
                                        name="box_name_search"
                                        inputProps={{ min: 1 }}
                                        value={boxNameScan}
                                        onInput={(e) => {
                                            setBoxNameScan(e.target.value)
                                        }
                                        }
                                        InputProps={{
                                            endAdornment: orderId ? (
                                                <IconButton size="small" onClick={() => onBoxNameScanClear()}>
                                                    <ClearIcon />
                                                </IconButton>
                                            ) : undefined,
                                        }}
                                        onKeyUp={(event) => {
                                            if (event.key == "Enter") {
                                                handleBoxScanSearch();
                                                // addBulkDimensionsForm()
                                            }
                                        }}
                                        onBlur={(e) => {
                                            e.target.blur(); // Ensures that focus is removed on blur
                                            setBoxNameFocus(false)
                                        }}
                                        inputRef={(boxnamescaninput) => {
                                            if(orderId!='' && orderSubmit && boxNameFocus)
                                                boxnamescaninput && boxnamescaninput.focus()
                                        }
                                        }
                                        style={{ width: '100%' }} />
                                </div>
                            }
                            <div className="sc--form--center" style={{ margin: '20px 0' }}>
                                <Autocomplete
                                    className="help-text-error"
                                    disablePortal
                                    name="choosenmeasurement"
                                    id="state-select-demo"
                                    sx={{ width: "100%", margin: '10px 0' }}
                                    options={boxData}
                                    autoHighlight
                                    loading={
                                        (box && box.loading)
                                    }
                                    getOptionLabel={(option) => option.box_name == 'custom' ? "" + option.box_name + "" : ("" + option.box_name + " (" + option.box_length + option.box_length_unit + "x " + option.box_width + option.box_width_unit + "x " + option.box_height + option.box_height_unit + ", " + option.box_weight + option.box_weight_unit + ")")}
                                    filterOptions={filterOptions}
                                    value={getChooseMeasurement(dimensionValue._id)}
                                    renderOption={(props, option) => (
                                        <MenuItem {...props} value={option._id} key={option._id}>
                                            {option.box_name == 'custom' ?
                                                <p style={{ margin: 'unset', color: 'rgba(0, 0, 0, 0.87)' }}>
                                                    {option.box_name}
                                                </p> :
                                                <p style={{ margin: 'unset', color: 'rgba(0, 0, 0, 0.87)' }}>
                                                    {option.box_name}(
                                                    {option.box_length}{option.box_length_unit} <span style={{ color: '#0082ff' }}> x </span>
                                                    {option.box_width}{option.box_width_unit} <span style={{ color: '#0082ff' }}> x </span>
                                                    {option.box_height}{option.box_height_unit}<span>, </span>
                                                    {option.box_weight}{option.box_weight_unit})
                                                </p>}
                                        </MenuItem>
                                    )}
                                    onChange={(event, value) => {
                                        if (value !== null) {
                                            let event = {
                                                "target": {
                                                    "name": "choosenmeasurement",
                                                    "value": value._id
                                                }
                                            }
                                            onBoxDimensionChange(event);
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Choose Measurement"
                                            variant="standard"
                                        />
                                    )}
                                />
                            </div>
                            <div className="sc--form--center" style={{ margin: '10px 0' }}>
                                <TextField id="standard-basic"
                                    label="Length"
                                    variant="standard"
                                    name="box_length"
                                    type="number"
                                    inputProps={{ min: 1 }}
                                    value={dimensionValue.box_length}
                                    onChange={event => onBoxDimensionChange(event)}
                                    error={dimensionsErrors.box_length}
                                    helperText={dimensionsErrors.box_length}
                                    style={{ width: '25%' }}
                                />
                                <TextField id="standard-basic"
                                    label="Width"
                                    variant="standard"
                                    name="box_width"
                                    type="number"
                                    inputProps={{ min: 1 }}
                                    value={dimensionValue.box_width}
                                    onChange={event => onBoxDimensionChange(event)}
                                    error={dimensionsErrors.box_width}
                                    helperText={dimensionsErrors.box_width}
                                    style={{ width: '25%' }}
                                />
                                <TextField id="standard-basic"
                                    label="Height"
                                    variant="standard"
                                    name="box_height"
                                    type="number"
                                    inputProps={{ min: 1 }}
                                    value={dimensionValue.box_height}
                                    onChange={event => onBoxDimensionChange(event)}
                                    error={dimensionsErrors.box_height}
                                    helperText={dimensionsErrors.box_height}
                                    style={{ width: '25%' }}
                                />
                                <FormControl
                                    variant="standard"
                                    className="help-text-error"
                                    style={{ width: '25%', margin: '8px' }}
                                >
                                    <InputLabel
                                        style={{ color: dimensionsErrors.box_dimension_unit ? "#D32F2F" : '' }}
                                    > Dim Unit
                                    </InputLabel>
                                    <Select
                                        name="box_dimension_unit"
                                        onChange={event => onBoxDimensionChange(event)}
                                        value={dimensionValue.box_dimension_unit}
                                        error={dimensionsErrors.box_dimension_unit}
                                        label="Dimension Unit"
                                        id="filled-error-helper-text"
                                    >
                                        <MenuItem value="in">in</MenuItem>
                                        <MenuItem value="cm">cm</MenuItem>
                                    </Select>
                                    <FormHelperText>{dimensionsErrors.box_dimension_unit}</FormHelperText>
                                </FormControl>

                            </div>
                            <div className="sc--form--center" style={{ margin: '10px 0' }}>
                                <TextField id="actual-weight-id"
                                    label="Actual weight"
                                    variant="standard"
                                    name="box_actual_weight"
                                    type="number"
                                    inputProps={{ min: 1 }}
                                    value={dimensionValue.box_actual_weight}
                                    autoFocus={true}
                                    onChange={event => onBoxDimensionChange(event)}
                                    error={dimensionsErrors.box_actual_weight}
                                    helperText={dimensionsErrors.box_actual_weight}
                                    style={{ width: '50%' }} />

                                <FormControl
                                    variant="standard"
                                    className="help-text-error"
                                    style={{ width: '50%', margin: '8px' }}
                                >
                                    <InputLabel
                                        id="demo-simple-select-standard-label"
                                        style={{ color: dimensionsErrors.box_weight_unit ? "#D32F2F" : '' }}
                                    > Weight Unit
                                    </InputLabel>
                                    <Select
                                        labelId="demo-simple-select-standard-label"
                                        name="box_weight_unit"
                                        onChange={event => onBoxDimensionChange(event)}
                                        value={dimensionValue.box_weight_unit}
                                        label="Weight Unit"
                                    >
                                        <MenuItem value="lb">lb</MenuItem>
                                        <MenuItem value="kg">kg</MenuItem>
                                        <MenuItem value="g">g</MenuItem>
                                    </Select>
                                    <FormHelperText>{dimensionsErrors.box_weight_unit}</FormHelperText>
                                </FormControl>
                            </div>
                            <div className="sc--form--center" style={{ margin: '20px auto 0px auto' }}>
                                <Button
                                    variant="varient"
                                    onClick={addBulkDimensionsForm}
                                    style={{
                                        color: orderId === "" || orders && orders.addBulkDimension && orders.addBulkDimension.loading || Object.keys(orderpicklistitems && orderpicklistitems.orderpickdetail &&
                                            orderpicklistitems.orderpickdetail.data).length===0? "rgba(0, 0, 0, 0.26)" : "#fff",
                                        backgroundColor:
                                            orderId === "" || orders && orders.addBulkDimension && orders.addBulkDimension.loading || Object.keys(orderpicklistitems && orderpicklistitems.orderpickdetail &&
                                                orderpicklistitems.orderpickdetail.data).length===0 ? "rgba(0, 0, 0, 0.12)" : "#1976d2",
                                        cursor: orderId ==="" || orders && orders.addBulkDimension && orders.addBulkDimension.loading || Object.keys(orderpicklistitems && orderpicklistitems.orderpickdetail &&
                                            orderpicklistitems.orderpickdetail.data).length===0 ? "not-allowed" : "pointer",
                                        pointerEvents: orderId === "" || orders && orders.addBulkDimension && orders.addBulkDimension.loading || Object.keys(orderpicklistitems && orderpicklistitems.orderpickdetail &&
                                            orderpicklistitems.orderpickdetail.data).length===0 ? "none" : "auto",
                                        marginLeft: "20px",
                                    }}                                
                                >
                                    Update
                                </Button>
                            </div>
                        </CardContent>
                    </div>
                </Card>
            </div>
        </>
    );
};

export default DimUpdatePage;
